<template>
  <validation-observer
    v-if="stepType === 'single' || isAdditional"
    v-show="isRenderAfterFullfilled"
    v-slot="observer"
    slim
  >
    <form-section
      id="use-of-other-vehicles"
      :validated="formObserver.validated"
      v-bind="observer"
    >
      <form-row
        :label="questionLabel"
        :error="formObserver.validated && observer.failed"
      >
        <template #helpText>
          <div class="d-flex align-start">
            <v-icon
              class="mr-4"
              color="primary"
            >
              mdi-credit-card-outline
            </v-icon>
            <p>
              <strong>Price sensitive question</strong><br>
              Some of our insurance providers may give a discount if {{ isAdditional ? 'they' : 'you' }} drive more than one vehicle.
            </p>
          </div>
        </template>
        <validation-provider
          v-slot="{ errors }"
          :vid="`${stepId}_use-of-other-vehicles`"
          name="Use of Other Vehicles"
          rules="listOptionRequired"
        >
          <qz-select
            v-model="questionData.useOfOtherVehicles"
            :data-test="fieldTrackerId"
            :items="useOfOtherVehicles"
            :error-messages="errors"
            :placeholder="helpers.getPlaceholderResponsiveText('Please select', isMobile)"
          />
        </validation-provider>
      </form-row>
    </form-section>
  </validation-observer>
</template>

<script>
import QuestionBase from './Base';
import { snakeCase } from 'lodash';

export default {
  name: 'question-use-of-other-vehicles',
  extends: QuestionBase,
  data () {
    return {
      fields: ['useOfOtherVehicles'],
    };
  },
  computed: {
    questionLabel () {
      if (this.isAdditional) {
        return `Do they drive any other ${this.productName === 'car' ? 'cars' : 'vehicles'}?`;
      }

      return 'Do you have the use of any other vehicles, other than the one to be insured?';
    },
    useOfOtherVehicles () {
      const options = this.optionsConfig?.options || this.constants.COVER_USE_OF_OTHER_VEHICLES;
      return this.helpers.createOptions({ source: options, asNumbers: !!this.optionsConfig?.options });
    },
    fieldTrackerId () {
      return snakeCase(this.questionFields.useOfOtherVehicles);
    },
  },
};
</script>
